import { mutationRequest } from "../request"
import {
  init_confirm_action_via_email_code_api_v1_users_path,
  confirm_action_via_email_code_api_v1_users_path,
} from "../../routes"

export interface InitConfirmActionViaEmailCodeParams {
  actionText: string
}

export interface ConfirmActionViaEmailCodeParams {
  actionText: string
  challengeCode: string
}

export interface SuccessResponse {
  success: boolean
}

/**
 * Initialize email confirmation code for an action
 * @param params - Parameters containing the action text
 * @returns Promise<SuccessResponse>
 */
export async function initConfirmActionViaEmailCode(
  params: InitConfirmActionViaEmailCodeParams,
): Promise<SuccessResponse> {
  try {
    const response = await mutationRequest({
      path: init_confirm_action_via_email_code_api_v1_users_path(),
      options: { method: "POST" },
      data: {
        action_text: params.actionText,
      },
    })
    return response
  } catch (error) {
    console.error("Error initializing confirm action via email code:", error)
    return {
      success: false,
    }
  }
}

/**
 * Confirm action via email code
 * @param params - Parameters containing the action text and challenge code
 * @returns Promise<SuccessResponse>
 */
export async function confirmActionViaEmailCode(
  params: ConfirmActionViaEmailCodeParams,
): Promise<SuccessResponse> {
  try {
    const response = await mutationRequest({
      path: confirm_action_via_email_code_api_v1_users_path(),
      options: { method: "POST" },
      data: {
        action_text: params.actionText,
        challenge_code: params.challengeCode,
      },
    })
    return response
  } catch (error) {
    console.error("Error confirming action via email code:", error)
    return {
      success: false,
    }
  }
}
